import { render, staticRenderFns } from "./AudioCard.vue?vue&type=template&id=0a1a4906&scoped=true&"
import script from "./AudioCard.vue?vue&type=script&lang=ts&"
export * from "./AudioCard.vue?vue&type=script&lang=ts&"
import style0 from "./AudioCard.vue?vue&type=style&index=0&id=0a1a4906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a4906",
  null
  
)

export default component.exports